/* LAE : vidéo de fond de la page de connexion.
   Normalement la balise <video> joue toute seule (muette, en boucle). Sur iPhone, deux réglages bloquent
   l'autoplay (Économie d'énergie, Accessibilité > Mouvement > Aperçus vidéo automatiques) : la vidéo reste
   figée avec un bouton play tant qu'on ne touche pas l'écran. Ici, si la lecture est refusée, on télécharge
   le fichier, on le décode avec WebCodecs et on dessine chaque image sur un canvas : aucune interaction requise.
   Classes sur <html> : gate-cv (canvas actif), gate-still (photo fixe qui respire, dernier recours).
   Test : ?gatecv=1 force le canvas, ?gatedbg=1 affiche les traces dans la console. */
(function(){
  var html=document.documentElement;
  var v=document.getElementById('gate-video'), cv=document.getElementById('gate-canvas');
  if(!v||!cv)return;
  /* 19 oct 2026 : mode connexion lente (html.lae-slow) = la photo seulement, aucun fichier vidéo à télécharger */
  if(html.classList.contains('lae-slow')||html.classList.contains('lae-restore'))return; /* + reconnexion d'un appareil connu : la porte ne se montre pas */
  var q=location.search||'';
  var forced=/[?&]gatecv=1/.test(q), forcedAnim=/[?&]gateanim=1/.test(q), dbg=/[?&]gatedbg=1/.test(q);
  var started=false, canvasOn=false, fetching=false, decided=false, bornAt=Date.now();
  var t0=0, W=0, H=0, ctx=null, dec=null, info=null, frames=[], feedIdx=0, loopN=0, raf=0, running=false, pending=0, fed=0, got=0, drawn=0;
  function src(){ return v.currentSrc||v.src||v.getAttribute('src')||''; }
  function log(){ if(!dbg)return; var a=['[gate '+(Date.now()-bornAt)+'ms]'].concat([].slice.call(arguments)); try{ console.log.apply(console,a); }catch(e){} if(location.port==='8765'){ try{ fetch('/__err?m='+encodeURIComponent(a.join(' '))); }catch(e){} } }

  v.addEventListener('playing',function(){ if(canvasOn||animOn){ try{v.pause();}catch(e){} return; } started=true; log('la vidéo joue'); });

  /* 5 oct 2026 : autoplay refusé → d'abord l'image animée WebP (joue partout, sans geste) ; le canvas WebCodecs ne sert plus que si l'image manque. */
  var an=document.getElementById('gate-anim'), animOn=false;
  function startAnim(why){
    if(!an){ startCanvas(); return; }
    var P=window.innerHeight>window.innerWidth, u=P?an.getAttribute('data-p'):an.getAttribute('data-l');
    if(!u){ startCanvas(); return; }
    an.addEventListener('load',function(){ animOn=true; html.classList.add('gate-anim'); try{ v.pause(); v.removeAttribute('autoplay'); }catch(e){} log('image animée :',why); },{once:true});
    an.addEventListener('error',function(){ log('image animée absente'); startCanvas(); },{once:true});
    an.src=u;
  }
  function decide(why){ if(started||canvasOn||animOn||decided)return; decided=true; startAnim(why); }
  if(forced){ decided=true; startCanvas(); }
  else if(forcedAnim){ decide('forcé (test)'); }
  else{
    try{ var p=v.play(); if(p&&p.catch)p.catch(function(err){ log('play refusé',err&&err.name); if(err&&err.name==='NotAllowedError')decide('NotAllowedError'); }); }catch(e){}
    var n=0, poll=setInterval(function(){
      n++;
      if(!v.paused&&v.currentTime>0)started=true;
      if(started||canvasOn||decided){ clearInterval(poll); return; }
      if(v.readyState>=2&&v.paused&&n>=3)decide('prête mais en pause');
      else if(n>=16)decide('rien après 8 s');
    },500);
  }

  function still(why){ log('photo fixe :',why); html.classList.add('gate-still'); html.classList.remove('gate-cv'); canvasOn=false; running=false; }

  function startCanvas(){
    if(canvasOn||fetching)return;
    var u=src();
    if(typeof VideoDecoder==='undefined'||typeof EncodedVideoChunk==='undefined'||!u){ still('WebCodecs absent'); return; }
    fetching=true;
    fetch(u).then(function(r){ if(!r.ok)throw new Error('http '+r.status); return r.arrayBuffer(); }).then(function(buf){
      info=parseMp4(buf); if(!info||!info.samples.length)throw new Error('mp4 illisible');
      log('mp4 :',info.codec,info.width+'x'+info.height,info.samples.length+' images',info.duration.toFixed(2)+' s');
      return VideoDecoder.isConfigSupported({codec:info.codec,description:info.avcC}).then(function(s){ if(!s.supported)throw new Error('codec non supporté '+info.codec); });
    }).then(boot).catch(function(e){ fetching=false; still(e&&e.message); });
  }

  function boot(){ try{ boot0(); }catch(e){ log('boot',e&&e.message); stop(); still('boot'); } }
  function boot0(){
    fetching=false; canvasOn=true;
    /* On neutralise la balise vidéo : plus de source, plus d'autoplay, plus de play() possible depuis le script inline. */
    try{ v.pause(); v.removeAttribute('autoplay'); v.removeAttribute('src'); var se=v.querySelector('source'); if(se)se.parentNode.removeChild(se); v.load(); }catch(e){}
    ctx=cv.getContext('2d',{alpha:false}); resize(); window.addEventListener('resize',resize);
    dec=new VideoDecoder({output:function(f){ pending=Math.max(0,pending-1); got++; frames.push(f); }, error:function(e){ log('décodeur',e&&e.message); stop(); still('décodeur'); }});
    dec.configure({codec:info.codec,description:info.avcC,optimizeForLatency:true});
    frames=[]; feedIdx=0; loopN=0; t0=0; pending=0; fed=0; got=0; drawn=0; running=true; feed(); raf=requestAnimationFrame(tick);
    if(dbg)setInterval(function(){ log('état : envoyées',fed,'décodées',got,'dessinées',drawn,'en attente',frames.length,'boucle',loopN); },2000);
    document.addEventListener('visibilitychange',function(){ if(!canvasOn)return; if(document.hidden){ running=false; cancelAnimationFrame(raf); } else { running=true; t0=0; raf=requestAnimationFrame(tick); } });
  }
  function stop(){ running=false; cancelAnimationFrame(raf); try{ while(frames.length)frames.shift().close(); }catch(e){} try{ if(dec&&dec.state!=='closed')dec.close(); }catch(e){} }
  function resize(){ var r=cv.getBoundingClientRect(); var dpr=Math.min(window.devicePixelRatio||1,2); W=Math.max(1,Math.round(r.width*dpr)); H=Math.max(1,Math.round(r.height*dpr)); cv.width=W; cv.height=H; }
  function feed(){
    if(!dec||dec.state!=='configured')return;
    var S=info.samples, ts=info.timescale, guard=0;
    /* Au plus 6 images en vol (envoyées ou décodées, pas encore affichées) : sinon Safari décode tout d'un coup et la mémoire explose. */
    while(pending+frames.length<6&&guard++<8){
      if(feedIdx>=S.length){ loopN++; feedIdx=0; }
      var s=S[feedIdx++];
      try{ pending++; fed++; dec.decode(new EncodedVideoChunk({type:s.key?'key':'delta',timestamp:Math.round((s.pts/ts+loopN*info.duration)*1e6),duration:Math.round(s.dur/ts*1e6),data:new Uint8Array(info.buf,s.off,s.size)})); }
      catch(e){ log('decode',e&&e.message); stop(); still('decode'); return; }
    }
  }
  function tick(now){
    if(!running)return;
    if(!cv.isConnected){ running=false; try{ if(dec)dec.close(); }catch(e){} return; } /* 19 oct 2026 : porte retirée, on arrête de décoder */
    raf=requestAnimationFrame(tick); feed();
    if(!frames.length)return;
    if(!t0)t0=now-frames[0].timestamp/1000;
    var t=(now-t0)*1000, f=null;
    while(frames.length&&frames[0].timestamp<=t){ if(f)f.close(); f=frames.shift(); }
    if(f){ draw(f); f.close(); drawn++; }
  }
  function draw(f){
    var fw=f.displayWidth||f.codedWidth, fh=f.displayHeight||f.codedHeight, sc=Math.max(W/fw,H/fh), dw=fw*sc, dh=fh*sc;
    ctx.drawImage(f,(W-dw)/2,(H-dh)/2,dw,dh);
    if(!html.classList.contains('gate-cv')){ html.classList.add('gate-cv'); log('première image dessinée'); }
  }

  /* Lecture minimale d'un MP4 (une seule piste vidéo H.264, faststart) : juste ce qu'il faut pour WebCodecs. */
  function parseMp4(buf){
    var dv=new DataView(buf), u8=new Uint8Array(buf);
    function str(p){ return String.fromCharCode(u8[p],u8[p+1],u8[p+2],u8[p+3]); }
    function boxes(s,e,cb){ var p=s; while(p+8<=e){ var sz=dv.getUint32(p), ty=str(p+4), h=8; if(sz===1){ sz=Number(dv.getBigUint64(p+8)); h=16; } else if(sz===0){ sz=e-p; } if(sz<h)break; cb(ty,p+h,p+sz); p+=sz; } }
    var moov=null; boxes(0,buf.byteLength,function(t,s,e){ if(t==='moov')moov=[s,e]; });
    if(!moov)return null;
    var out=null;
    boxes(moov[0],moov[1],function(t,s,e){ if(t==='trak'&&!out)out=trak(s,e); });
    return out;
    function trak(s,e){
      var mdia=null; boxes(s,e,function(t,a,b){ if(t==='mdia')mdia=[a,b]; }); if(!mdia)return null;
      var ts=0, vid=false, stbl=null;
      boxes(mdia[0],mdia[1],function(t,a,b){
        if(t==='mdhd')ts=(u8[a]===1)?dv.getUint32(a+20):dv.getUint32(a+12);
        else if(t==='hdlr')vid=(str(a+8)==='vide');
        else if(t==='minf')boxes(a,b,function(t2,c,d){ if(t2==='stbl')stbl=[c,d]; });
      });
      if(!vid||!stbl||!ts)return null;
      var codec=null, avcC=null, width=0, height=0, stts=[], ctts=null, stss=null, stsc=[], sizes=null, fixed=0, count=0, stco=null;
      boxes(stbl[0],stbl[1],function(t,a,b){
        var i,n;
        if(t==='stsd'){ var p=a+8; var sz=dv.getUint32(p), ty=str(p+4); if(ty==='avc1'||ty==='avc3'){ width=dv.getUint16(p+32); height=dv.getUint16(p+34); boxes(p+86,p+sz,function(t2,c,d){ if(t2==='avcC'){ avcC=u8.slice(c,d); codec='avc1.'+[u8[c+1],u8[c+2],u8[c+3]].map(function(x){ return ('0'+x.toString(16)).slice(-2); }).join(''); } }); } }
        else if(t==='stts'){ n=dv.getUint32(a+4); for(i=0;i<n;i++)stts.push([dv.getUint32(a+8+i*8),dv.getUint32(a+12+i*8)]); }
        else if(t==='ctts'){ ctts=[]; n=dv.getUint32(a+4); for(i=0;i<n;i++)ctts.push([dv.getUint32(a+8+i*8),dv.getInt32(a+12+i*8)]); }
        else if(t==='stss'){ stss={}; n=dv.getUint32(a+4); for(i=0;i<n;i++)stss[dv.getUint32(a+8+i*4)]=1; }
        else if(t==='stsc'){ n=dv.getUint32(a+4); for(i=0;i<n;i++)stsc.push([dv.getUint32(a+8+i*12),dv.getUint32(a+12+i*12)]); }
        else if(t==='stsz'){ fixed=dv.getUint32(a+4); count=dv.getUint32(a+8); if(!fixed){ sizes=[]; for(i=0;i<count;i++)sizes.push(dv.getUint32(a+12+i*4)); } }
        else if(t==='stco'){ stco=[]; n=dv.getUint32(a+4); for(i=0;i<n;i++)stco.push(dv.getUint32(a+8+i*4)); }
        else if(t==='co64'){ stco=[]; n=dv.getUint32(a+4); for(i=0;i<n;i++)stco.push(Number(dv.getBigUint64(a+8+i*8))); }
      });
      if(!codec||!avcC||!stco||!count||!stts.length)return null;
      var samples=[], dts=0, k=0, ci=0, ei=0;
      for(var c=0;c<stco.length&&samples.length<count;c++){
        while(ci+1<stsc.length&&stsc[ci+1][0]<=c+1)ci++;
        var per=stsc[ci][1], off=stco[c];
        for(var j=0;j<per&&samples.length<count;j++){
          var idx=samples.length, size=fixed||sizes[idx];
          while(k<stts.length&&stts[k][0]===0)k++; var dur=stts[k]?stts[k][1]:stts[stts.length-1][1]; if(stts[k])stts[k][0]--;
          var cto=0; if(ctts){ while(ei<ctts.length&&ctts[ei][0]===0)ei++; if(ctts[ei]){ cto=ctts[ei][1]; ctts[ei][0]--; } }
          samples.push({off:off,size:size,dts:dts,pts:dts+cto,dur:dur,key:stss?!!stss[idx+1]:true});
          off+=size; dts+=dur;
        }
      }
      return {codec:codec,avcC:avcC,width:width,height:height,timescale:ts,duration:dts/ts,samples:samples,buf:buf};
    }
  }
})();
